import { Helmet } from "react-helmet-async"
import { MonthlyUsersReport } from "../../../../../Admin/TenantReports"

export default function MonthlyUsersReportPage() {
	return (
		<>
			<Helmet>
				<title>Monthly Accounts: Users</title>
			</Helmet>
			<MonthlyUsersReport />
		</>
	)
}
